<template>
    <div class="app--engagement-auth-web-signin">
        <form novalidate ref="identify" @submit.prevent="identify($event)" v-if="!section">
            <div v-if="!response.title" class="message text--color-default">{{trans('auth.email_only_message')}}</div>
            <div v-if="response.title" class="alert alert-dismissible" :class="response.class">
                <strong>{{response.title}}</strong>
                <p v-if="response.description">{{response.description}}</p>
                <button type="button" class="btn-close" @click="close"></button>
            </div>
            <div class="form-group">
                <div class="input-group">
                    <span class="input-group-text" :class="classes('input')"><app-icon value="email"></app-icon></span>
                    <input type="email" autocomplete="off" class="form-control" required autofocus 
                        v-model="field.email" 
                        :class="classes('input')"
                        :placeholder="trans('auth.email').charAt(0).toUpperCase() + trans('auth.email').slice(1)"
                    />
                </div>
                <div class="invalid-feedback"></div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
                <app-button class="app--button border--button primary" type="submit" 
                    :loading="loading" 
                    :label="trans('buttons.next')"
                ></app-button>
                <app-button class="app--button muted"
                    :disabled="loading" 
                    :label="trans('buttons.cancel')"
                    @click.native="cancel"
                ></app-button>
            </div>
            <div class="d-flex align-items-center justify-content-start mt-3" v-if="canSignup">
                <div class="text--color-default me-1">{{trans('auth.signup')}}</div>
                <a href="javascript:void(0)" class="pfp-engagement-link m-0" @click="signup">
                    <span class="text--size-lead">{{trans('auth.signup_button')}}</span>
                </a>
            </div>
        </form>

        <form novalidate ref="send" @submit.prevent="send($event)" v-if="section == 'EMAIL' || section == 'SMS' || section == 'RESET'">
            <div v-if="!response.title && section != 'RESET'" class="message text--color-default">
                <span v-html="trans('auth.signin_message')" />
                <div class="text-center text--color-default">
                    {{ trans('buttons.the') }} {{section == 'EMAIL' ? trans('auth.email') : trans('auth.phone_number')}}: 
                     <span class="font-monospace text--color-muted px-1">{{label}}</span>
                </div>
            </div>
            <div v-if="!response.title && section == 'RESET'" class="message text--color-default">
                <span v-html="trans('auth.password_forgot')" />
                <div class="text-center text--color-default">
                    {{ trans('buttons.the') }} {{section == 'EMAIL' ? trans('auth.email') : trans('auth.phone_number')}}: 
                     <span class="font-monospace text--color-muted px-1">{{label}}</span>
                </div>
            </div>
            <div v-if="response.title" class="alert alert-dismissible" :class="response.class">
                <strong>{{response.title}}</strong>
                <p v-if="response.description">{{response.description}}</p>
                <button type="button" class="btn-close" @click="close"></button>
            </div>
            <div class="d-flex align-items-center justify-content-between">
                <app-button class="app--button border--button primary" type="submit" 
                    :loading="loading" 
                    :label="trans('buttons.pin')"
                ></app-button>
                <app-button class="app--button muted"
                    :disabled="loading" 
                    :label="trans('buttons.cancel')"
                    @click.native="cancel"
                ></app-button>
            </div>
        </form>

        <form novalidate ref="verify" @submit.prevent="verify($event)" v-if="section == 'PINRESET' || section == 'PIN'">
            <div v-if="!response.title" class="message text--color-default">
                <span v-html="trans('auth.pin_message')" />
                <div class="text-center text--color-default">
                      {{method == 'EMAIL' ? trans('auth.email') : trans('auth.phone_number')}}: 
                     <span class="font-monospace text--color-muted px-1">{{label}}</span>
                </div>
            </div>
            <div v-if="response.title" class="alert alert-dismissible" :class="response.class">
                <strong>{{response.title}}</strong>
                <p v-if="response.description">{{response.description}}</p>
                <button type="button" class="btn-close" @click="close"></button>
            </div>
            <div class="form-group">
                <div class="input-group">
                    <span class="input-group-text" :class="classes('input')">#</span>
                    <input type="text" ref="pin" required class="form-control" 
                        v-model="field.pin" 
                        :class="classes('input')" 
                        :placeholder="trans('auth.pin_number')" 
                    />
                </div>
                <div class="invalid-feedback"></div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
                <app-button class="app--button border--button primary" type="submit" 
                    :loading="loading" 
                    :label="trans('buttons.verify')"
                ></app-button>
                <app-button class="app--button muted"
                    :disabled="loading" 
                    :label="trans('buttons.cancel')"
                    @click.native="cancel"
                ></app-button>
            </div>
        </form>

        <form novalidate ref="signin" @submit.prevent="signin($event)" v-if="section == 'PASSWORD'">
            <div v-if="!response.title" class="message text--color-default">
                {{trans('auth.password_message')}}
            </div>
            <div v-if="response.title" class="alert alert-dismissible" :class="response.class">
                <strong>{{trans(response.title)}}</strong>
                <p v-if="response.description">{{trans(response.description)}}</p>
                <button type="button" class="btn-close" @click="close"></button>
            </div>
            <div class="form-group">
                <field-password v-model:value="field.password" :placeholder="trans('auth.password')" :autofocus="true"
                    :validate-minlength="0" :validate-strength="false" :classes="classes('input')">
                    <template v-slot:prepend>
                       <span class="input-group-text" :class="classes('input')"><app-icon value="lock"></app-icon></span>
                    </template>
                </field-password>
            </div>
            <div class="form-group" v-if="label">
                <a href="javascript:void(0);" class="pfp-engagement-link" @click.prevent="section = 'RESET'">
                    {{trans('buttons.forgot')}}
                </a>
            </div>
            <div class="d-flex align-items-center justify-content-between">
                <app-button class="app--button border--button primary" type="submit" 
                    :loading="loading" 
                    :label="trans('buttons.signin')"
                ></app-button>
                <app-button class="app--button muted"
                    :disabled="loading" 
                    :label="trans('buttons.cancel')"
                    @click.native="cancel"
                ></app-button>
            </div>
        </form>

        <form novalidate ref="create" @submit.prevent="create($event)" v-if="section == 'CREATE'">
            <div v-if="!response.title" class="message text--color-default">
                {{trans('auth.password_message')}}
            </div>
            <div v-if="response.title" class="alert alert-dismissible" :class="response.class">
                <strong>{{trans(response.title)}}</strong>
                <p v-if="response.description">{{trans(response.description)}}</p>
                <button type="button" class="btn-close" @click="close"></button>
            </div>
            <div class="form-group">
                <field-password v-model:value="field.password" :placeholder="trans('auth.password')" 
                    :classes="classes('input')">
                    <template v-slot:prepend>
                        <span class="input-group-text" :class="classes('input')"><app-icon value="lock"></app-icon></span>
                    </template>
                </field-password>
            </div>
            <div class="form-group">
                <field-password v-model:value="field.password_confirm" :placeholder="trans('auth.password_confirm')"
                    :validate-confirm="field.password" :validate-minlength="0" :validate-strength="false" :classes="classes('input')">
                    <template v-slot:prepend>
                        <span class="input-group-text" :class="classes('input')"><app-icon value="lock"></app-icon></span>
                    </template>
                </field-password>
            </div>
            <div class="d-flex align-items-center justify-content-between">
                <app-button class="app--button border--button primary" type="submit" 
                    :loading="loading" 
                    :label="trans('buttons.create')"
                ></app-button>
                <app-button class="app--button muted"
                    :disabled="loading" 
                    :label="trans('buttons.cancel')"
                    @click.native="cancel"
                ></app-button>
            </div>
        </form>
    </div>
</template>

<script>
    import store from '../../../store'
    import Password from '../../../../components/Password'

    export default {
        props: {
            pages: {type: Array, required: true }
        },
        computed: {
            method()    { return store.state.auth.method   },
            response()  { 
                let response = store.state.auth.response
                if (response && response.title && response.class && response.class == 'alert-danger') {
                    response.title = this.trans(response.title)
                    response.description = response.description ? this.trans(response.description) : ''
                }
                return response  
            },
            member()    { return store.state.members.find(m => m.active == true) },
            canSignup() { return store.state.signup == true && store.state.security == 'HIGH' },
        },
        data() {
            return {
                loading: false,
                label: '',
                section: '',
                field: { 
                    email: '', 
                    password: '', 
                    password_confirm: '',
                    pin: '' 
                }
            }
        },
        beforeUnmount() {
            if (this.$refs.signin) {
                this.$validationReset(this.$refs.signin)
            }
            this.field  = {email:'',  password:'', password_confirm:'', pin:''}
            this.label  = ''
            this.section= ''
        },
        methods: {
            cancel() {
                store.dispatch('auth/cancel')
            },
            classes(index) { 
                return store.getters['classes'](index) 
            },
            close() {
                store.commit('auth/SET_RESPONSE', null)
            },
            signup() {
                store.commit('auth/SET_RESPONSE', null)
                store.commit('auth/SET_ACTIVE', 'websignup')
            },
            identify(event) {
                if (this.loading) return;
                this.$validate(event).then(() => {
                    this.loading = true
                    store.dispatch('auth/webidentify', {email: this.field.email, method: this.method}).then((response) => {
                        this.loading = false
                        this.label   = response.label
                        this.section = response.method == 'SMS' && this.method == 'PASSWORD' ? 'RESET' : response.method
                    })
                })
            },
            send(event) {
                if (this.loading) return;
                this.$validate(event).then(() => {
                    this.loading = true
                    store.dispatch('auth/webpin', {email: this.field.email}).then((response) => {
                        this.loading = false
                        this.section = this.section == 'RESET' ? 'PINRESET' : 'PIN'
                    })
                })
            }, 
            verify(event) {
                if (this.loading) return;
                this.$validate(event).then(() => {
                    this.loading = true
                    store.dispatch('auth/webverify', {email: this.field.email, pin: this.field.pin}).then((response) => {
                        if (response === true) {
                            store.dispatch('open').then(response => { 
                                this.loading = false
                                this.close()
                                store.commit('auth/SET_ACTIVE', null)
                                store.commit('SET_PAGE', this.pages[1]) 
                            })
                        } else {
                            this.loading = false
                            if (this.section == 'PINRESET' && response !== false) {
                                this.close()
                                this.section = 'CREATE'
                            }
                        }
                    })
                })
            },
            create(event) {
                if (this.loading) return;
                this.$validate(event).then(() => {
                    this.loading = true
                    this.close()
                    return store.dispatch('auth/webpassword', this.field)
                }).then((response) => {
                    if (response === true) { 
                        store.dispatch('open').then(response => { 
                            this.close()
                            this.loading = false
                            store.commit('auth/SET_ACTIVE', null)
                            store.commit('SET_PAGE', this.pages[1]) 
                        })
                    } else {
                        this.field.password = ''
                        this.field.password_confirm = ''
                        this.loading = false
                    }
                })
            },
            signin(event) {
                if (this.loading) return;
                this.$validate(event).then(() => {
                    this.loading = true
                    this.close()
                    return store.dispatch('auth/websignin', this.field)
                }).then((response) => {
                    if (response === true) { 
                        store.dispatch('open').then(response => { 
                            this.close()
                            store.commit('auth/SET_ACTIVE', null)
                            store.commit('SET_PAGE', this.pages[1]) 
                        })
                    } else {
                        this.field.password = ''
                        this.loading = false
                    }
                })
            },
            trans(key) {
                return store.getters.trans(key)
            },
        },
        components: {
            'field-password': Password
        }
    }
</script>
